import axios from "axios";
import { url_301 } from "../api_services";
import {
  clearAwaitPaymentFromUrl,
  isPaymentCompleted,
  isPaymentStillPending,
  extractMid,
  extractOrderId,
  extractPaymentUrl,
  extractTxnToken,
  normalizePaymentStatus,
  PAYTM_MAX_POLL_MS,
  PAYTM_POLL_INTERVAL_MS,
  shouldFinalizeAfterPaytmReturn,
  shouldFinalizePayment,
} from "./paytmHelpers";

export const PAYTM_HANDBOOK_CHECKOUT_FRAME = "paytm_handbook_checkout_frame";
export const PAYTM_HANDBOOK_PENDING_ORDER_KEY = "paytm_handbook_pending_order_id";

export {
  clearAwaitPaymentFromUrl,
  extractOrderId,
  isPaymentCompleted,
  isPaymentStillPending,
  normalizePaymentStatus,
  PAYTM_MAX_POLL_MS,
  PAYTM_POLL_INTERVAL_MS,
  shouldFinalizeAfterPaytmReturn,
  shouldFinalizePayment,
};

export const savePendingHandbookOrderId = (orderId) => {
  if (orderId) {
    sessionStorage.setItem(PAYTM_HANDBOOK_PENDING_ORDER_KEY, orderId);
  }
};

export const getPendingHandbookOrderId = () =>
  sessionStorage.getItem(PAYTM_HANDBOOK_PENDING_ORDER_KEY) || "";

export const clearPendingHandbookOrderId = () => {
  sessionStorage.removeItem(PAYTM_HANDBOOK_PENDING_ORDER_KEY);
};

export const initiateHandbookPaytmOrder = async (payload) => {
  const response = await axios.post(url_301, payload);

  if (response.data?.status !== 200) {
    throw new Error(response.data?.message || "Failed to initiate handbook order.");
  }

  const responseData = response.data?.data || response.data;
  const orderId = extractOrderId(responseData);

  if (!orderId) {
    throw new Error("Order id not received from handbook initiate API.");
  }

  return { orderId, responseData };
};

export const submitHandbookPaytmCheckoutInFrame = (
  paytmData,
  frameName = PAYTM_HANDBOOK_CHECKOUT_FRAME
) => {
  const paymentUrl = extractPaymentUrl(paytmData);
  const mid = extractMid(paytmData);
  const orderIdValue = extractOrderId(paytmData);
  const txnToken = extractTxnToken(paytmData);

  if (paymentUrl) {
    const frame = document.getElementsByName(frameName)[0];
    if (frame) {
      frame.src = paymentUrl;
      return true;
    }
    return false;
  }

  if (!mid || !orderIdValue || !txnToken) {
    return false;
  }

  const form = document.createElement("form");
  form.method = "POST";
  form.target = frameName;
  form.action = `https://securegw.paytm.in/theia/api/v1/showPaymentPage?mid=${encodeURIComponent(
    mid
  )}&orderId=${encodeURIComponent(orderIdValue)}`;

  const fields = [
    ["body", JSON.stringify({ head: { txnToken } })],
    ["head", JSON.stringify({ txnToken })],
    ["txnToken", txnToken],
    ["mid", mid],
    ["orderId", orderIdValue],
  ];

  fields.forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);

  return true;
};
